import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const FileUploadCellContainer = styled.div({
  display: 'flex',
  minHeight: '40px',
  border: `solid 1px ${v.borderFile}`,
  borderRadius: '5px',
  boxShadow: `${v.boxShadow}`,
  alignItems: 'center',
  marginTop: '15px',
  width: '100%',
  wordWrap: 'anywhere',
  wordBreak: 'break-word',
  justifyContent: 'space-between',

  '& .left, & .right': {
    display: 'flex',
    alignItems: 'center',
  },

  '& .left': {
    maxWidth:'80%',
    minWidth:'60%',
  },

  '& .right': {
    maxWidth:'40%',
    justifyContent: 'flex-end',
  },

  '& .right button.ui.button': {
    marginLeft: '10px',
    marginRight: '0px',
    borderRadius: '0px 5px 5px 0px',
    background: 'transparent',
    borderLeft: `solid 1px ${v.borderFile}`,
  },

  '& .right button.ui.button svg path': {
    color: `${v.textRed}`,
  },

  '.iconContent': {
    display: 'flex',
    height: 'auto',
    width: '40px',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.iconContent svg path': {
    color: `${props => props.pendingDelete ? v.textGray : v.ezMainColor}`,
  },

  '.titleContent': {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    fontSize: '12px',
  },

  '.fileNameContent': {
    color: `${props => props.pendingDelete ? v.textGray : v.textBlack}`,
    textDecoration: `${props => props.pendingDelete ? 'line-through' : 'none'}`,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    overflow: 'hidden',
    maxWidth:'100%'
  },

  '.fileSizeContent': {
    whiteSpace: 'nowrap',
    color: `${props => props.pendingDelete ? v.textGray : v.textBlack}`,
    textDecoration: `${props => props.pendingDelete ? 'line-through' : 'none'}`,
  },

  '@media only screen and (min-width: 600px)': {
    whiteSpace: 'nowrap',
  },

  '@media only screen and (min-width: 769px)': {
    whiteSpace: 'nowrap',
  },
})